import { useMemo, useState } from "react";

import { TInputTag } from "components/InputMultipleTag";

import { queryGetBranchList } from "@type/api/user";
import { useAuthStore } from "@type/store";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

interface UseGetBranchOfficeListProps {
  enabled?: boolean;
}

export const useGetBranchOfficeList = ({
  enabled,
}: UseGetBranchOfficeListProps) => {
  const user = useAuthStore((state) => state.user);
  const [branchOfficeOptions, setBranchOfficeOptions] = useState<TInputTag[]>(
    []
  );

  const queryGetBranchListKey = useMemo(() => {
    return queryGetBranchList._key(user.language);
  }, [user.language]);

  const { isLoading } = useQueryWithCallbacks({
    queryKey: queryGetBranchListKey,
    enabled: !!user?.idUnique && enabled,
    queryFn: () => queryGetBranchList(user.language),
    onSuccess: (res) => {
      const branchList: TInputTag[] = res.data.branchOffices.map((branch) => ({
        id: branch.id,
        name: branch.name,
      }));
      branchList.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );
      setBranchOfficeOptions(branchList);
    },
  });

  return {
    isLoadingBranchOffice: isLoading,
    branchOfficeOptions,
  };
};
